import { getMappingRegex } from './utils/get-mapping-regex';
export var getMatchedMapping = function (urlMappings, url) {
    if (urlMappings === void 0) { urlMappings = []; }
    return urlMappings.find(function (mapping) { return getMappingRegex(mapping).test(url); });
};
export var getMatchedMappingIndex = function (urlMappings, url) {
    if (urlMappings === void 0) { urlMappings = []; }
    return urlMappings.findIndex(function (mapping) { return getMappingRegex(mapping).test(url); });
};
//# sourceMappingURL=get-matched-mapping.js.map